import React from "react";
import { Link } from "react-router-dom";
import "./welcome.css";

const WelcomePage = () => {
  return (
    <div className="welcome-page">
      <header>
        <div className="wrap bar">
          <Link to="/" className="brand" aria-label="Konnect.ws home">
            Konnect.ws
          </Link>
        </div>
      </header>

      <main>
        <div className="wrap">
          <h1>Connecting you to everything you need</h1>
          <p className="lead">
            Hot meals, weekly shopping, wholesale and everyday items, all in one order.
          </p>
          <div className="actions">
            <Link className="btn btn-primary" to="/signup">
              Create a free account
            </Link>
            <Link className="btn btn-secondary" to="/signin">
              Log in to your account
            </Link>
          </div>
        </div>
      </main>
    </div>
  );
};

export default WelcomePage;
